import React from 'react';
var Content = function (props) {
    return (React.createElement("div", { className: 'onboarding-popover-wrapper' },
        React.createElement("div", { className: 'onboarding-popover-content' }, props.content),
        props.operationArea
            && React.createElement("div", { className: 'onboarding-popover-operation-area' }, props.operationArea)));
};
export default Content;
